import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { imageProxy } from "@/data/site";
import { useLang } from "@/lib/i18n";

export default function AreaCard({ area }) {
  const { t } = useLang();
  const imgUrl = area.image && area.image.startsWith("http")
    ? imageProxy(area.image, { w: 800, q: 78 })
    : area.image;

  return (
    <Link
      to={`/service-areas/${area.slug}`}
      data-testid={`area-card-${area.slug}`}
      className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white hover:shadow-xl transition-all duration-300"
    >
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={imgUrl}
          alt={area.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-brand-navy-dark/95 via-brand-navy-dark/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
        <div className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-brand-yellow">
          <MapPin size={12} /> {t.common.southFlorida}
        </div>
        <h3 className="mt-1 font-heading text-2xl font-bold">{area.name}</h3>
        <p className="text-sm text-white/85 mt-1 line-clamp-2">{area.short}</p>
        <div className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-brand-yellow">
          <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
        </div>
      </div>
    </Link>
  );
}
